"use client";

import { Button } from "@boostdev/design-system-components/client";
import { DownloadIcon } from "@/components/atoms/icons/DownloadIcon";

export interface DownloadButtonProps {
  readonly href: string;
  readonly label: string;
  readonly onDownloadStart: () => void;
  readonly className?: string;
}

/**
 * Icon-only DS Button rendering as an anchor, so the browser's native
 * same-origin download (via Content-Disposition on the proxy response)
 * handles the file save.
 */
export function DownloadButton({
  href,
  label,
  onDownloadStart,
  className,
}: DownloadButtonProps) {
  return (
    <Button
      href={href}
      isIconOnly
      aria-label={label}
      onClick={onDownloadStart}
      className={className}
      // @ts-expect-error — DS Button's types don't include the anchor-only
      // `download` attribute, but it spreads ...rest onto the underlying <a>.
      download
    >
      <DownloadIcon size={24} />
    </Button>
  );
}
